<template>
    <div>
        <div class="banner-admin-only mx-4">
            <span class="mdi mdi-information-outline"></span> <span>Schedule Reports page is restricted to <b>Admin</b> users Only</span>
        </div>
        <div class="p-4 scheduled-report-page" data-app="true">
        <div :style="scheduledReportBanner.isShow ? 'bottom: 0;' : 'bottom: -10rem;'"
            :class="scheduledReportBanner.class" class="report-banner" style="z-index: 51;">
            <div class="d-flex align-items-center"><b>{{ scheduledReportBanner.text }}</b></div>
        </div>
        
        <div class="">
            <h4 class="text-capitalize ma-0 font-weight-bold" style="margin-bottom: 16px;">Scheduled Reports</h4>
            <p class="ma-0">Create exports from any report template, choose when to send them, and we deliver them automatically. Schedule reports weekly or monthly, and select recipients to ensure the right people receive the right data.</p>
        </div>
        <div v-if="showList" class="mt-4">
            <div class="d-flex w-100 justify-content-between">
                <div class="d-flex align-items-center " style="column-gap: 0.8rem">
                    <CSelectNew @input="onSort" v-model="query.sort" :options="sortOptions" :itemValue="'id'"
                        :itemText="'name'" class="py-0 sort-select"></CSelectNew>
                    <div class="search-container position-relative" style="width: 400px">
                        <CInput class="search-bar" @input="searchWithDebounce" :placeholder="'Search by schedule name'"
                            :type="'text'"></CInput>
                        <v-icon small class="bg-white position-absolute p-2" style="right: 0.5rem; top: 4px"
                            color="rgba(79, 79, 79, 1)">mdi-magnify</v-icon>
                    </div>
                    <div class="filter"  >
                        <v-menu content-class="scheduled-report-filter-menu" min-width="300px" bottom
                            :close-on-content-click="false"  nudge-bottom="35px">
                            <template v-slot:activator="{ on, attrs }">
                                <div class="d-flex justify-content-between align-items-center" role="button"
                                    v-bind="attrs" v-on="on">
                                    <span class="mr-2">Filter</span>
                                    <v-icon color="#BDBDBD" small>mdi-chevron-down</v-icon>
                                </div>
                            </template>
                            <div class="bg-white" style="width: 370px;">
                                <div class="font-weight-bold px-3 py-2 mb-3">Filter</div>

                                <div class="mb-3 px-3">
                                    <p class="m-0 mb-2"><b>Status</b></p>
                                    <div>
                                        <input class="mr-2" v-model="allValue.status" @input="onClearArray('status')"
                                            type="checkbox" :value="'true'" />
                                        <label>All</label>
                                    </div>
                                    <div v-for="stat in statusOptions" :key="stat.id">
                                        <input class="mr-2" @input="onClearAllValue('status')" type="checkbox"
                                            :value="stat.id" v-model="filter.status" />
                                        <label>{{ stat.name }}</label>
                                    </div>
                                </div>

                                <div class="author mb-3 px-3" id="created-by-filter">
                                    <span class="mb-2 font-weight-bold d-block">Created by</span>
                                    <v-autocomplete v-model="filter.created_by_id" :items="members"
                                        :search-input.sync="searchMember"
                                        :menu-props="{ attach: true }"
                                        item-value="id"
                                        item-text="name" label="Search" append-icon="mdi-magnify" solo dense flat
                                        color="#007BFF" item-color="#007BFF"
                                        hide-details hide-no-data multiple small-chips deletable-chips cache-items
                                        @update:search-input="" @change="searchMember = ''"></v-autocomplete>
                                <v-divider color="#D7D7D7" class="ma-0"></v-divider>

                                </div>

                                <div class="mb-3 px-3">
                                    <span class="mb-2 font-weight-bold d-block">Category Report Template</span>
                                    <CSelect v-model="filter.category_report_template" :options="categoryOptions"
                                        :itemValue="'value'" :itemText="'label'" class="py-0"></CSelect>
                                </div>

                                <div class="mb-3 px-3">
                                    <span class="mb-2 font-weight-bold d-block">Report Template</span>
                                    <CSelect v-model="filter.report_template_id" :options="reportTemplateOptionsWithAll"
                                        :itemValue="'id'" :itemText="'name'"
                                        :disabled="!filter.category_report_template || filter.category_report_template === 'all'"
                                        class="py-0"></CSelect>
                                </div>

                                <hr style="border: 1px solid #D7D7D7;" class="ma-0" />
                                <div class="d-flex action justify-content-between p-3">
                                    <CButton @click.native="clearAdditionalFilter" :outline="true" :color="'#007BFF'"
                                        label="Clear">
                                    </CButton>
                                    <CButton @click.native="applyFilter" :color="'#007BFF'" label="Apply">
                                    </CButton>
                                </div>
                            </div>
                        </v-menu>
                    </div>
                </div>
                <div class="create-btn">
                    <a href="/dashboard/scheduled_report/new">
                        <button class="btn btn-outline-primary d-flex align-items-center">
                            <v-icon small color="#007BFF" class="mr-1">mdi-plus</v-icon>
                            New Schedule Report
                        </button>
                    </a>

                </div>
            </div>
        </div>
        <div v-if="showList" class="my-4">
            <ReportListTable :key="null" :items="scheduleReports" :headers="headers"
                :perPage="reportPagination.per_page" :totalItems="reportPagination.total_count"
                @loadPerPage="loadPerPage" @loadData="loadData" @reloadData="reloadData" @showBanner="showBanner" />
        </div>
        <ScheduledReportEmptyState v-else-if="showEmptyState" />
    </div>
    </div>
    
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import ReportListTable from './ReportListTable.vue'
import ScheduledReportEmptyState from './ScheduledReportEmptyState.vue'
import CInput from '../c-input.vue';
import CSelect from '../../components/c-select.vue';
import CSelectNew from '../../components/c-select-new.vue';
import CButton from '../../components/c-button.vue'
import _ from 'lodash'

export default {
    components: {
        ReportListTable,
        ScheduledReportEmptyState,
        CInput,
        CSelect,
        CSelectNew,
        CButton,
    },
    props: {

    },
    data() {
        return {
            headers: [
                { text: 'Name', value: 'name', width: 220 },
                { text: 'Report Template Name', value: 'template_name', width: 140 },
                { text: 'Category', value: 'category', width: 70 },
                { text: 'Recipient', value: 'recipient', width: 260 },
                { text: 'Frequency', value: 'frequency', width: 80 },
                { text: 'Created by', value: 'created_by', width: 90 },
                { text: 'Status', value: 'status', width: 70 },
                { text: 'Created At', value: 'created_at', width: 120 },
                { text: '', value: 'action', width: 230 },
            ],
            showModal: false,
            modalType: 'new',
            sortOptions: [
                { id: 'latest', name: 'Created date - Latest' },
                { id: 'oldest', name: 'Created date - Oldest' },
                { id: 'name_asc', name: 'Name - Ascending' },
                { id: 'name_desc', name: 'Name - Descending' },
                { id: 'status_asc', name: 'Status - Active, Inactive' },
                { id: 'status_desc', name: 'Status - Inactive, Active' },
            ],
            previousSort: 'latest',
            query: {
                search: '',
                sort: 'latest',
                filter: {
                    created_by_id: [],
                    status: [],
                    category_report_template: 'all',
                    report_template_id: 'all',
                }
            },
            filter: {
                created_by_id: [],
                status: [],
                category_report_template: 'all',
                report_template_id: 'all',
            },
            allValue: {
                status: 'true',
            },
            statusOptions: [
                { id: 'active', name: 'Active' },
                { id: 'inactive', name: 'Inactive' },
            ],
            categoryOptions: [
                { value: 'all', label: 'All' },
                { value: 'Report::Case', label: 'Cases' },
                { value: 'Report::Client', label: 'Clients' },
                { value: 'Report::Join', label: 'Join (Cases & Clients)' },
                { value: 'Report::Sales', label: 'Sales' },
                { value: 'Report::Ticket', label: 'Tickets' },
            ],
            searchMember: null,
            hasLoaded: false,
        };
    },
    computed: {
        ...mapGetters({
            reportSchedules: 'reportSchedules/reportSchedules',
            reportPagination: 'reportSchedules/reportPagination',
            members: 'reportSchedules/members',
            reportTemplateOptions: 'reportSchedules/reportTemplates',
            scheduledReportBanner: 'scheduledReportBanner',
            isLoadingTemplate: 'reportSchedules/isLoadingTemplate',
        }),
        reportTemplateOptionsWithAll() {
            return [{ id: 'all', name: 'All' }, ...(this.reportTemplateOptions || [])];
        },
        scheduleReports() {
            return (this.reportSchedules || []).map((schedule) => {
                const recipients = (schedule.report_schedule_recipients || [])
                    .map((entry) => entry.recipient)
                    .filter(Boolean);
                const createdBy = schedule.created_by || null;
                return {
                    id: schedule.id,
                    name: schedule.name,
                    template_name: schedule.report_template_name,
                    category: schedule.category,
                    recipients: recipients,
                    frequency: schedule.frequency ? this.formatFrequency(schedule.frequency) : '',
                    created_by: createdBy
                        ? {
                            ...createdBy,
                            color: createdBy.avatar_color || createdBy.color,
                        }
                        : null,
                    status: schedule.status,
                    created_at: schedule.created_at,
                };
            });
        },
        isDefaultQuery() {
            const filter = this.query.filter || {};
            const createdBy = Array.isArray(filter.created_by_id) ? filter.created_by_id : [];
            const statusValues = Array.isArray(filter.status) ? filter.status : [];
            const category = filter.category_report_template;
            const template = filter.report_template_id;

            return !this.query.search
                && createdBy.length === 0
                && statusValues.length === 0
                && (!category || category === 'all')
                && (!template || template === 'all');
        },
        showEmptyState() {
            return this.hasLoaded
                && !this.isLoadingTemplate
                && this.reportPagination.total_count === 0
                && this.isDefaultQuery;
        },
        showList() {
            return !this.showEmptyState;
        },
    },
    methods: {
        ...mapActions({
            fetchReportSchedules: 'reportSchedules/getReportSchedules',
            fetchReportTemplates: 'reportSchedules/getReportTemplates',
        }),
        ...mapMutations({
            setPagination: 'reportSchedules/setReportPagination',
            setIsLoadingTemplate: 'reportSchedules/setIsLoadingTemplate',
            setReportTemplates: 'reportSchedules/setReportTemplates',
        }),
        openModal(type) {
            this.showModal = true
            this.modalType = type
        },
        toggleModal(payload) {
            this.showModal = payload
        },
        loadData(newPage) {
            this.setPagination({
                current_page: newPage,
            });
            this.$router.replace({ query: { ...this.$route.query, page: newPage } }).catch(err => {
                // Ignore NavigationDuplicated error
                if (err.name !== 'NavigationDuplicated') {
                    throw err;
                }
            });
            this.loadReportSchedules();
        },
        loadPerPage(perPage) {
            this.setPagination({
                current_page: 1,
                per_page: perPage,
            });
            this.loadReportSchedules();
        },
        onSort() {
            if (this.query.sort !== this.previousSort) {
                this.previousSort = this.query.sort;
                this.setPagination({ current_page: 1 });
                this.loadData(1);
            }
        },
        onSearch(e) {
            this.query.search = e;
            this.setPagination({ current_page: 1 });
            this.loadData(1);
        },
        searchWithDebounce: _.debounce(function (e) {
            this.onSearch(e);
        }, 500),
        clearAdditionalFilter() {
            this.filter = {
                created_by_id: [],
                status: [],
                category_report_template: 'all',
                report_template_id: 'all',
            };
            this.allValue.status = 'true';
            this.setReportTemplates([]);
            this.applyFilter();
        },
        async applyFilter() {
            const createdByIds = Array.isArray(this.filter.created_by_id)
                ? this.filter.created_by_id
                : [this.filter.created_by_id].filter(Boolean);
            const statusValues = Array.isArray(this.filter.status)
                ? this.filter.status
                : [this.filter.status].filter(Boolean);

            const filter = {
                created_by_id: createdByIds,
                status: statusValues,
                category_report_template: this.filter.category_report_template === 'all' ? '' : this.filter.category_report_template,
                report_template_id: this.filter.report_template_id === 'all' ? '' : this.filter.report_template_id,
            };

            this.query.filter = filter;
            this.setPagination({ current_page: 1 });
            this.loadData(1);
        },
        fetchMembers(query) {
            this.$store.dispatch('reportSchedules/getMembers', { query: query })
        },
        onClearArray(attribute) {
            this.filter = { ...this.filter, [attribute]: [] };
        },
        onClearAllValue(attribute) {
            this.allValue[attribute] = '';
        },
        loadReportSchedules() {
            const selectedSort = (this.query.sort || 'latest').toString();
            const legacySortMap = {
                newest: 'latest',
            };
            const normalizedSort = legacySortMap[selectedSort] || selectedSort;
            const filter = this.query.filter || {};

            this.setIsLoadingTemplate(true);
            this.fetchReportSchedules({
                query: this.query.search || '',
                sort: normalizedSort,
                filter: filter,
            }).finally(() => {
                this.setIsLoadingTemplate(false);
                this.hasLoaded = true;
            });
        },
        reloadData() {
            this.loadReportSchedules();
        },
        showBanner(message) {
            if (!message) return;
            this.$store.commit('setScheduledReportBannerSuccess', message);
        },
        formatFrequency(value) {
            if (!value) return '';
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
    },
    watch: {
        searchMember: _.debounce(function (val) {
            val && this.fetchMembers(val)
        }, 500),
        'filter.category_report_template': function (val, oldVal) {
            if (val !== oldVal) {
                this.filter.report_template_id = 'all';
                this.fetchReportTemplates({ category: val });
                if (!val || val === 'all') {
                    this.setReportTemplates([]);
                }
            }
        },
    },
    mounted() {
        const pageFromQuery = Number(this.$route.query.page) || 1;
        const perPageFromQuery = Number(this.$route.query.perPage) || this.reportPagination.per_page;
        const snackbarMessage = this.$route?.query?.snackbar || new URLSearchParams(window.location.search).get('snackbar');
        if (snackbarMessage) {
            this.$store.commit('setScheduledReportBannerSuccess', snackbarMessage);
        }

        this.setPagination({
            current_page: pageFromQuery,
            per_page: perPageFromQuery,
        });

        this.loadReportSchedules();
        this.fetchMembers('');
    },
};
</script>

<style lang="scss" scoped>
// .scheduled-report-page {
//     position: relative;
// }
.banner-admin-only{
    font-weight: 400;
    color: #3F3F3F;
    padding: 16px;
    background-color: #FFF2E0;
}

.report-banner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    font-size: 1em;
    left: 5rem;
    right: 2rem;
    width: auto;
    transition: 1s;
    padding: 0 2rem;
    height: 4.5rem;
    font-family: 'Lato';
    box-sizing: border-box;
}

.bg-green-banner {
    background: #E5FFEC !important;
}

.bg-red-banner {
    background: #FFEDED !important;
}

.text-red-banner {
    color: #D43F3A !important;
}

.filter {
    width: 120px;
    background: white;
    border: 1px solid #BDBDBD;
    border-radius: 4px;
    padding: 8px;
}

.sort-select {
    width: 230px!important;
    min-width: 230px!important;
}

.author ::v-deep .v-select__selections {
    gap: 6px 0;
    padding: 8px 0;
}

::v-deep .scheduled-report-filter-menu {
    width: 370px !important;
    max-width: 370px !important;
}

</style>
